// src/routes/RouteGuards.js
import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../shared/hooks/useAuth';
import { useWarmupTimer } from '../shared/hooks/useWarmupTimer';
import Loading from '../shared/components/Loading';

export const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();
    const { isWarmup } = useWarmupTimer(isLoading);

    if (isLoading) return <Loading isWarmup={isWarmup} />;
    if (!isAuthenticated) return <Navigate replace to="/login" />;

    return children;
};

export const PermissionRoute = ({ permission, redirectTo = '/competitions', children }) => {
    const { isAuthenticated, isLoading, hasPermission } = useAuth();
    const { isWarmup } = useWarmupTimer(isLoading);

    if (isLoading) return <Loading isWarmup={isWarmup} />;
    if (!isAuthenticated) return <Navigate replace to="/login" />;
    if (!hasPermission(permission)) return <Navigate replace to={redirectTo} />;

    return children;
};

export const PublicRoute = ({ children }) => {
    const { isLoading } = useAuth();
    const { isWarmup } = useWarmupTimer(isLoading);

    if (isLoading) return <Loading isWarmup={isWarmup} />;

    return children;
};

export const AdminRoute = ({ children }) => {
    const { isAuthenticated, isLoading, hasPermission } = useAuth();
    const { isWarmup } = useWarmupTimer(isLoading);

    const adminPermissions = [
        'users:managePermissions',
        'activities:handleExemptions',
        'competition:create',
        'competition:edit',
        'strava:resync',
        'strava:viewAthletes',
    ];

    if (isLoading) return <Loading isWarmup={isWarmup} />;
    if (!isAuthenticated) return <Navigate replace to="/login" />;
    if (!adminPermissions.some(hasPermission)) return <Navigate replace to="/fithub" />;

    return children;
};

const routeGuardProps = {
    children: PropTypes.node.isRequired
};

ProtectedRoute.propTypes = routeGuardProps;
PermissionRoute.propTypes = {
    permission: PropTypes.string.isRequired,
    redirectTo: PropTypes.string,
    children: PropTypes.node.isRequired,
};
PublicRoute.propTypes = routeGuardProps;
AdminRoute.propTypes = routeGuardProps;
